import {$post} from "./base"
export async function ruleindex(){
    return $post("/role/index")
}